import type { Translations } from './en.js';

const ja: Translations = {
  ok: 'OK',
  cancel: 'キャンセル',
  close: '閉じる',
  confirm: '確認',
  retry: '再試行',
  back: '戻る',
  settings: '設定',
  language: '言語',
  score: 'スコア',
  level: 'レベル',
  game_over: 'ゲームオーバー',
  restart: 'リスタート',
  pause: '一時停止',
  resume: '再開',
  settings_sound: 'サウンド',
  settings_music: '音楽',
  settings_reset: 'リセット',
  settings_reset_confirm: '全進行状況をリセットしますか？',
  ad_watch: '広告を見る',
  ad_reward: '無料報酬',
  ad_loading: '広告読み込み中...',
  ad_reward_received: '報酬を受け取りました！',
  ad_not_completed: '広告が完了していません',
  offline_title: 'おかえりなさい！',
  offline_earned: '留守中の獲得',
  sp: 'SP',
  fame: '名声',
  building_tab: '建物',
  ghosts_tab: '幽霊',
  shop_tab: 'ショップ',
  prestige_tab: 'プレステージ',
  training_tab: '訓練',
  facilities_tab: '付帯施設',
  reviews_tab: 'レビュー',
  floor_label: '{n}階',
  buy_floor: '階を購入',
  buy_floor_cost: '階を購入 ({sp} SP)',
  unlock_slot: 'スロット解放',
  unlock_slot_cost: 'スロット解放 ({sp} SP)',
  build_room: '部屋を建設',
  upgrade_room: '部屋をアップグレード',
  upgrade_room_cost: 'アップグレード ({sp} SP)',
  room_empty: '空き',
  room_locked: 'ロック中',
  no_ghost: '幽霊なし',
  assign_ghost: '幽霊を配置',
  visitors_floor: 'この階の訪問客',
  add_floor: '階を追加',
  add_floor_cost: '+ 新しい階 ({sp} SP)',
  menu_tab: 'メニュー',
  room_dark_corridor: '暗闇の廊下',
  room_dark_corridor_desc: '心理恐怖 +30%',
  room_mirror_room: '鏡の部屋',
  room_mirror_room_desc: '視覚 +25%、心理 +15%',
  room_dungeon: '地下牢',
  room_dungeon_desc: '心理 +20%、物理 +20%',
  room_graveyard: '墓地の部屋',
  room_graveyard_desc: '心理恐怖 +40%',
  room_lab: '実験室',
  room_lab_desc: '視覚 +30%、物理 +20%',
  room_library: '図書室',
  room_library_desc: '心理 +35%、聴覚 +15%',
  room_coffin_room: '棺桶の部屋',
  room_coffin_room_desc: '視覚 +30%、心理 +20%',
  room_doll_room: '人形の部屋',
  room_doll_room_desc: '視覚 +20%、心理 +35%',
  room_kitchen: '呪いの台所',
  room_kitchen_desc: '物理 +30%、聴覚 +20%',
  room_bathroom: '幽霊トイレ',
  room_bathroom_desc: '心理 +30%、聴覚 +25%',
  room_funhouse: 'ミラーメイズ',
  room_funhouse_desc: '視覚+35%, 心理+20%',
  room_trapeze_room: 'トランペツルーム',
  room_trapeze_room_desc: '物理+30%, 視覚+15%',
  room_freak_show: 'フリークショー',
  room_freak_show_desc: '視覚+40%, 心理+30%',
  room_sacrifice_altar: '祭壇',
  room_sacrifice_altar_desc: '心理+40%, 視覚+20%',
  room_treasure_vault: '宝物庫',
  room_treasure_vault_desc: '心理+20%, 聴覚+20%',
  room_underground_river: '地下川',
  room_underground_river_desc: '聴覚+30%, 心理+20%',
  room_curse_chamber: '呪いの部屋',
  room_curse_chamber_desc: '心理+45%, 物理+15%',
  room_mummy_tomb: 'ミラの墓',
  room_mummy_tomb_desc: '視覚+30%, 心理+30%',
  room_captain_cabin: '船長室',
  room_captain_cabin_desc: '心理+30%, 視覚+20%',
  room_cargo_hold: '貨物室',
  room_cargo_hold_desc: '物理+25%, 聴覚+20%',
  room_davy_jones_locker: 'デイビィ・ジョーンズのロッカー',
  room_davy_jones_locker_desc: '心理+35%, 視覚+25%',
  room_brig: '監禁室',
  room_brig_desc: '物理+30%, 心理+20%',
  room_crows_nest: '鴉の巣',
  room_crows_nest_desc: '物理+35%, 視覚+20%',
  room_mine_shaft: '鉱山坑道',
  room_mine_shaft_desc: '物理+30%, 聴覚+20%',
  room_crystal_cave: '水晶洞窟',
  room_crystal_cave_desc: '視覚+35%, 聴覚+15%',
  room_explosives_storage: '爆薬庫',
  room_explosives_storage_desc: '物理+40%, 聴覚+25%',
  room_underground_lake: '地下湖',
  room_underground_lake_desc: '心理+30%, 聴覚+25%',
  room_rail_tunnel: 'トンネル',
  room_rail_tunnel_desc: '物理+30%, 心理+20%',
  room_throne_room: '玉座の間',
  room_throne_room_desc: '視覚+25%, 心理+30%',
  room_wine_cellar: 'ワインセラー',
  room_wine_cellar_desc: '心理+30%, 視覚+15%',
  room_tower_chamber: '塔の部屋',
  room_tower_chamber_desc: '心理+35%, 物理+20%',
  room_server_room: 'サーバー室',
  room_server_room_desc: '聴覚+30%, 視覚+20%',
  room_quarantine_zone: '隔離区域',
  room_quarantine_zone_desc: '心理+35%, 物理+20%',
  room_armory: '武器庫',
  room_armory_desc: '物理+35%, 視覚+20%',
  room_witch_hut: '魔女の小屋',
  room_witch_hut_desc: '視覚+30%, 心理+25%',
  room_treehouse: 'ツリーハウス',
  room_treehouse_desc: '物理+25%, 聴覚+20%',
  room_swamp_path: '沼地の道',
  room_swamp_path_desc: '心理+30%, 聴覚+20%',
  room_fairy_ring: '妖精の輪',
  room_fairy_ring_desc: '心理+40%, 視覚+20%',
  room_ancient_ruin: '古代遺跡',
  room_ancient_ruin_desc: '心理+35%, 視覚+25%',
  room_attic: '屋根裏',
  room_attic_desc: '心理+30%, 聴覚+15%',
  room_secret_passage: '秘密の通路',
  room_secret_passage_desc: '心理+35%, 物理+15%',
  room_morgue: '遺体安置所',
  room_morgue_desc: '視覚+30%, 心理+30%',
  room_surgery_room: '手術室',
  room_surgery_room_desc: '物理+35%, 視覚+25%',
  room_music_room: '音楽室',
  room_music_room_desc: '聴覚+40%, 心理+20%',
  room_science_lab: '科学実験室',
  room_science_lab_desc: '視覚+30%, 物理+25%',
  room_ticket_booth: 'チケットブース',
  room_ticket_booth_desc: '心理+25%, 視覚+20%',
  room_animal_cage: '動物檻',
  room_animal_cage_desc: '物理+30%, 視覚+25%',
  room_clown_tent: 'ピエロテント',
  room_clown_tent_desc: '心理+40%, 視覚+20%',
  room_hall_of_mirrors: '鏡の間',
  room_hall_of_mirrors_desc: '視覚+40%, 心理+30%',
  room_elevator_shaft: 'エレベーター坑道',
  room_elevator_shaft_desc: '物理+35%, 心理+20%',
  room_ore_processing: '鉱石処理場',
  room_ore_processing_desc: '聴覚+30%, 物理+20%',
  room_collapsed_tunnel: '崩壊トンネル',
  room_collapsed_tunnel_desc: '物理+40%, 心理+25%',
  room_miners_quarters: '坑夫宿舎',
  room_miners_quarters_desc: '心理+30%, 視覚+20%',
  room_command_center: '指揮統制室',
  room_command_center_desc: '心理+30%, 聴覚+25%',
  room_ventilation_shaft: '換気ダクト',
  room_ventilation_shaft_desc: '物理+35%, 聴覚+25%',
  room_decontamination: '除染室',
  room_decontamination_desc: '心理+35%, 視覚+25%',
  room_hollow_tree: '虚ろの大木',
  room_hollow_tree_desc: '視覚+30%, 心理+25%',
  room_spider_nest: '蜘蛛の巣窟',
  room_spider_nest_desc: '視覚+35%, 物理+25%',
  room_moonlit_clearing: '月明かりの空地',
  room_moonlit_clearing_desc: '心理+40%, 聴覚+20%',
  room_abandoned_cabin: '廃小屋',
  room_abandoned_cabin_desc: '心理+30%, 視覚+20%',

  room_ward_room: '病室',
  room_ward_room_desc: '心理+30%, 視覚+20%',
  room_reception_hall: '受付ホール',
  room_reception_hall_desc: '心理+25%, 聴覚+20%',
  room_x_ray_room: 'レントゲン室',
  room_x_ray_room_desc: '視覚+35%, 物理+20%',
  room_classroom: '教室',
  room_classroom_desc: '心理+30%, 聴覚+15%',
  room_art_room: '美術室',
  room_art_room_desc: '視覚+35%, 心理+20%',
  room_gymnasium: '体育館',
  room_gymnasium_desc: '物理+30%, 聴覚+25%',
  room_rooftop: '屋上',
  room_rooftop_desc: '心理+40%, 物理+20%',
  room_crypt: '地下納骨堂',
  room_crypt_desc: '視覚+35%, 心理+25%',
  room_powder_room: '火薬庫',
  room_powder_room_desc: '物理+40%, 聴覚+20%',
  room_navigation_room: '航海室',
  room_navigation_room_desc: '心理+30%, 視覚+20%',
  room_banquet_hall: '宴会場',
  room_banquet_hall_desc: '心理+30%, 視覚+20%',
  room_chapel: '礼拝堂',
  room_chapel_desc: '心理+40%, 聴覚+20%',
  room_torture_chamber: '拷問室',
  room_torture_chamber_desc: '物理+40%, 視覚+30%',
  room_armory_hall: '武器展示室',
  room_armory_hall_desc: '物理+30%, 視覚+25%',
  room_science_room: '研究室',
  room_science_room_desc: '視覚+30%, 心理+20%',

  unlock_requires_day: '{n}日目以上',
  unlock_requires_fame: '名声{n}+',
  unlock_requires_room: '前提: {name}',
  unlock_condition_not_met: '条件未達成',
  room_repair_needed: '修理が必要',
  room_repairing: '修理中',
  room_cleaning: '清掃中',
  ghost_roster: '幽霊リスト',
  ghost_idle: '待機中',
  ghost_assigned: '配置済み',
  ghost_fatigue: '疲労度',
  ghost_level: 'Lv.{n}',
  ghost_exp: '経験値 {cur}/{max}',
  ghost_level_up: 'レベルアップ',
  recover_fatigue: '疲労回復 ({sp} SP)',
  ghost_fatigued_warning: '疲弊！効率 -50%',
  unassign_ghost: '配置解除',
  ghost_training_in_progress: '訓練中...',
  shop_ghosts: '幽霊を雇う',
  shop_rooms: '部屋タイプ',
  hire: '雇用',
  hire_cost: '{sp} SP',
  already_hired: '雇用済み',
  not_enough_sp: 'SPが足りません！',
  unlock_room_type: '解放',
  unlock_cost: '{sp} SP',
  already_unlocked: '解放済み',
  grade_c: 'Cランク',
  grade_b: 'Bランク',
  grade_a: 'Aランク',
  grade_s: 'Sランク',
  ghost_jinaeryeong: '女の幽霊',
  ghost_gangsi: 'キョンシー',
  ghost_vampire: 'ヴァンパイア',
  ghost_kappa: 'カッパ',
  ghost_pierrot: 'ピエロ',
  ghost_banshee: 'バンシー',
  ghost_origin_korea: '韓国',
  ghost_origin_china: '中国',
  ghost_origin_romania: 'ルーマニア',
  ghost_origin_japan: '日本',
  ghost_origin_usa: 'アメリカ',
  ghost_origin_ireland: 'アイルランド',
  ghost_jinaeryeong_skill: '髪の毛落下: 天井から落ちて物理恐怖を追加',
  ghost_gangsi_skill: '硬直ジャンプ: 硬直した姿勢で飛び跳ね、2人同時に恐怖',
  ghost_vampire_skill: '催眠の眼: 訪問客1人を10秒間凍らせ、次の部屋+30%',
  ghost_kappa_skill: '皿スピン: 頭の皿を回転させ視覚恐怖',
  ghost_pierrot_skill: '笑い攻撃: 突然の登場、道化師恐怖',
  ghost_banshee_skill: '絶叫: 聴覚恐怖最強、連続発動可能',
  ghost_jinaeryeong_quote: '今日は10人を驚かせました、ボス！',
  ghost_gangsi_quote: '飛び跳ねるのは大変だ...',
  ghost_vampire_quote: '夜は長く、私は永遠だ。',
  ghost_kappa_quote: '水をこぼすな！',
  ghost_pierrot_quote: 'なぜそんなに真剣なの？',
  ghost_banshee_quote: '叫びすぎて喉が痛い。',
  ghost_jinaeryeong_fatigued: 'ボス...髪がボサボサ。休みたいです！',
  ghost_gangsi_fatigued: 'もう動けない...本当に。',
  ghost_vampire_fatigued: '不死身でも休息が必要...',
  ghost_kappa_fatigued: '皿が乾いた、水が必要！',
  ghost_pierrot_fatigued: 'もう笑えない、ボス。',
  ghost_banshee_fatigued: '声が出ない！絶叫できない！',
  room_unlock_in_shop: 'ショップで解放',
  visitor_scaredy_kid: '怖がりの子',
  visitor_scaredy_kid_desc: '怖がりだが少しの恐怖でも満足',
  visitor_normal: '一般客',
  visitor_normal_desc: '平均的な恐怖耐性',
  visitor_brave: '肝っ玉',
  visitor_brave_desc: '高い耐性、満足時は大きな報酬',
  visitor_couple: 'カップル',
  visitor_couple_desc: '適度な恐怖、高い報酬、良いレビュー',
  visitor_youtuber: 'YouTuber',
  visitor_youtuber_desc: 'レビューの影響力が2.5倍',
  visitor_exorcist: 'エクソシスト',
  visitor_exorcist_desc: '怖がらせるのがほぼ不可能、莫大な報酬',
  visitor_thrill_seeker: 'スリルシーカー',
  visitor_thrill_seeker_desc: '激しい恐怖を求める、弱いと不満',
  visitor_coward: '臆病者',
  visitor_coward_desc: '全てを怖がる、すぐ逃げる',
  time_phase_day: '昼',
  time_phase_evening: '夕方',
  time_phase_night: '夜',
  time_phase_rain: '雨',
  reputation_label: '評判: {n}',
  scare_chain: 'チェーン x{n}！',
  terror_max: '恐怖絶頂！',
  sp_earned: '+{sp} SP',
  prestige_title: 'フランチャイズ拡大',
  prestige_desc: 'お化け屋敷が世界的に有名になりました！フランチャイズを開業しますか？',
  prestige_requirement_floors: '{n}階以上必要',
  prestige_requirement_fame: '名声 {n}以上必要',
  prestige_requirement_sp: '総獲得SP {n}以上必要',
  prestige_not_ready: '条件未達成',
  prestige_confirm: 'フランチャイズ開業',
  prestige_level: 'プレステージ Lv.{n}',
  prestige_bonus: '全幽霊恐怖 +{n}%、開始SP +{sp}',
  offline_collect: '受け取る',

  // === Training System ===
  training_title: '演技レッスン',
  training_select: '訓練を選ぶ',
  training_cost: '{sp} SP',
  training_duration: '{sec}秒',
  training_in_progress: '訓練中...',
  training_complete: '訓練完了！',
  training_bonus: '恐怖力 +{pct}%',
  training_skip_ad: 'スキップ（広告）',
  training_count: '{n}回修了',
  training_ghost_busy: '先に配置を解除してください',
  training_already: '訓練中です',

  training_scream_practice: '叫び練習',
  training_scream_practice_desc: '声の投射とタイミングの向上',
  training_jumpscare_acting: 'ジャンプスケア演技',
  training_jumpscare_acting_desc: '突然の登場の技術を習得',
  training_psychological_acting: '心理的恐怖演技',
  training_psychological_acting_desc: '持続的な不安感の演出を学ぶ',
  training_atmosphere_directing: '雰囲気演出',
  training_atmosphere_directing_desc: '照明、音響、霧の演出制御',
  training_physical_training: '体力トレーニング',
  training_physical_training_desc: 'エネルギッシュな恐怖のための体力作り',
  training_audience_analysis: '観客分析',
  training_audience_analysis_desc: '最適な恐怖のための訪問者行動研究',

  tq_jinaeryeong_scream: '女の幽霊がYouTubeでホラー映画分析中...',
  tq_gangsi_scream: 'キョンシーが硬直した姿勢で叫び練習中...',
  tq_vampire_scream: 'ヴァンパイアが地下室でオペラをハミング中...',
  tq_kappa_scream: 'カッパがバケツで水中叫び練習中...',
  tq_pierrot_scream: 'ピエロが風船に向かって叫び練習中...',
  tq_banshee_scream: 'バンシーが初心者にマスタークラス開催中...',

  tq_jinaeryeong_jumpscare: '女の幽霊がクローゼットから繰り返し飛び出す中...',
  tq_gangsi_jumpscare: 'キョンシーがジャンプ練習前にストレッチ中...',
  tq_vampire_jumpscare: 'ヴァンパイアが劇的なマント披露の練習中...',
  tq_kappa_jumpscare: 'カッパがトイレからポップアップ練習中...',
  tq_pierrot_jumpscare: 'ピエロが風船割りのタイミングをリハーサル中...',
  tq_banshee_jumpscare: 'バンシーが登場の振り付け練習中...',

  tq_jinaeryeong_psych: '女の幽霊が心理学の教科書を勉強中...',
  tq_gangsi_psych: 'キョンシーが不気味な表情の練習中（元からだけど）...',
  tq_vampire_psych: 'ヴァンパイアが鏡の前で表情練習中...（映らないけど）',
  tq_kappa_psych: 'カッパが図書館の本で人間の恐怖を学習中...',
  tq_pierrot_psych: 'ピエロが「IT」を50回目視聴中...',
  tq_banshee_psych: 'バンシーが不気味なささやき台本を執筆中...',

  tq_jinaeryeong_atmo: '女の幽霊が最大の不気味さのために髪を整え中...',
  tq_gangsi_atmo: 'キョンシーが霧マシンの設定を調整中...',
  tq_vampire_atmo: 'ヴァンパイアが完璧なろうそくの角度を選択中...',
  tq_kappa_atmo: 'カッパが様々な水滴音をテスト中...',
  tq_pierrot_atmo: 'ピエロが蓄光塗料で壁を塗装中...',
  tq_banshee_atmo: 'バンシーが廊下のエコー効果を調整中...',

  tq_jinaeryeong_physical: '女の幽霊が天井這い運動中...',
  tq_gangsi_physical: 'キョンシーが硬直した脚でスクワット中...',
  tq_vampire_physical: 'ヴァンパイアが棺の中で腕立て伏せ中...',
  tq_kappa_physical: 'カッパが池でスイムラップ中...',
  tq_pierrot_physical: 'ピエロが腹筋しながらジャグリング中...',
  tq_banshee_physical: 'バンシーが声帯のウォーミングアップ中...',

  tq_jinaeryeong_audience: '女の幽霊がオンラインの訪問者レビューを読んでいる...',
  tq_gangsi_audience: 'キョンシーが訪問者の動線パターンを研究中...',
  tq_vampire_audience: 'ヴァンパイアが恐怖の人口統計を分析中...',
  tq_kappa_audience: 'カッパがどの年齢層が水を怖がるか調査中...',
  tq_pierrot_audience: 'ピエロが道化師恐怖症の統計を追跡中...',
  tq_banshee_audience: 'バンシーが音波周波数の恐怖反応を研究中...',

  // === Props ===
  props_title: '部屋の装飾品',
  prop_buy: '購入 ({sp} SP)',
  prop_upgrade: 'アップグレード ({sp} SP)',
  prop_max: '最大',
  prop_level: 'Lv.{n}',
  prop_bonus: '+{pct}% 恐怖',

  prop_cobwebs: 'クモの巣',
  prop_cobwebs_desc: '定番の不気味な雰囲気',
  prop_candles: 'ゆらめくろうそく',
  prop_candles_desc: '不気味に揺れる影',
  prop_blood_pool: '血の水たまり',
  prop_blood_pool_desc: '恐ろしい床の装飾',
  prop_skull_decor: 'ドクロの装飾',
  prop_skull_decor_desc: '背筋が凍るディスプレイ',
  prop_fog_machine: '霧マシン',
  prop_fog_machine_desc: '濃い神秘的な霧',
  prop_creaky_floor: 'きしむ床板',
  prop_creaky_floor_desc: '一歩ごとに音が鳴る',
  prop_eerie_painting: '不気味な絵画',
  prop_eerie_painting_desc: '追いかけてくる視線',
  prop_chains: 'ガチャガチャ鳴る鎖',
  prop_chains_desc: '不気味な金属音',

  // Staging Equipment
  prop_dry_ice: 'ドライアイスマシン',
  prop_dry_ice_desc: '地面に濃い霧を作り出し恐怖の雰囲気を演出',
  prop_scent_sprayer: '香り噴霧器',
  prop_scent_sprayer_desc: '不快な臭いで恐怖への没入感を高める',
  prop_strobe_light: 'ストロボライト',
  prop_strobe_light_desc: '点滅する閃光で訪問者の感覚を撹乱',
  prop_surround_speaker: 'サラウンドスピーカー',
  prop_surround_speaker_desc: '立体音響で背筋が凍る効果音を再生',
  prop_vibration_floor: '振動フロアパネル',
  prop_vibration_floor_desc: '足元から突然の振動が発生',
  prop_temp_controller: '温度コントローラー',
  prop_temp_controller_desc: '突然の冷風で心理的恐怖を与える',
  prop_hologram_device: 'ホログラムデバイス',
  prop_hologram_device_desc: '部屋に幽霊の幻影を投影',
  prop_auto_lock: '自動ドアロック',
  prop_auto_lock_desc: '訪問者の後ろでドアが突然閉まる',
  props_category_decoration: '装飾小道具',
  props_category_staging: '演出装置',
  props_staging_desc: 'プロ級の恐怖演出のための高級機材',

  // === Facilities ===
  facilities_title: '付帯施設',
  facility_build: '建設 ({sp} SP)',
  facility_upgrade: 'アップグレード ({sp} SP)',
  facility_level: 'Lv.{n}',
  facility_built: '建設済み',

  facility_haunted_house: 'お化け屋敷',
  facility_haunted_house_desc: 'ホラー体験メイン建物',
  facility_haunted_house_bonus: 'メイン建物入口',
  facility_enter: '入場',

  facility_ticket_booth: 'チケット売り場',
  facility_ticket_booth_desc: '来場者にチケットを販売します',
  facility_ticket_booth_bonus: '最大来場者数増加',
  facility_ticket_booth_visitors: '人',

  facility_gift_shop: 'ギフトショップ',
  facility_gift_shop_desc: 'お化け屋敷のお土産を販売',
  facility_gift_shop_bonus: '訪問者グループごとに +{sp} SP',
  facility_snack_bar: '売店',
  facility_snack_bar_desc: '不気味なスナックとドリンク',
  facility_snack_bar_bonus: '訪問者報酬 +{pct}%',
  facility_photo_booth: 'フォトブース',
  facility_photo_booth_desc: '恐怖セルフィーステーション',
  facility_photo_booth_bonus: '訪問者グループごとに +{sp} SP',

  // === Reviews ===
  reviews_title: '訪問者レビュー',
  reviews_empty: 'まだレビューがありません。訪問者を待ちましょう！',
  reviews_fame_bonus: '+{n} 名声',
  review_stars: '{n}つ星',
  reviews_avg: '平均: {n}つ星',

  review_5_1: '本当に怖かった！特に3階の{ghost}は別格！',
  review_5_2: '史上最高のお化け屋敷！叫びすぎて声が枯れた！',
  review_5_3: '{ghost}の演技はオスカー級！10点満点で10点！',
  review_5_4: '魂が抜けかけた。お金の価値あり！',
  review_4_1: '{ghost}はかなり怖かったが、上の階はもう少し期待してた。',
  review_4_2: '雰囲気最高！ほぼ漏らすところだった。ほぼ。',
  review_4_3: '{ghost}は印象的だったがタイミングがもう少し。',
  review_4_4: '全体的にしっかりした恐怖。友達にも勧めたい！',
  review_3_1: 'まあまあ。空き部屋があって雰囲気が壊れた。',
  review_3_2: '{ghost}は今日疲れてるみたい。休んだら？',
  review_3_3: '普通の体験。装飾がもっと必要。',
  review_2_1: '{ghost}が仕事中に寝てた。返金希望。',
  review_2_2: '怖いというより面白い。幽霊に演技レッスンが必要。',
  review_2_3: '{ghost}は頑張ったけど...全然怖くなかった。',
  review_1_1: '空き部屋だらけ。ここ営業してるの？',
  review_1_2: '返金してほしい。うちのばあちゃんの方が怖い。',
  review_1_3: '{ghost}が手を振ってきた。振ったんだよ。それお化けか？',

  // === Ad Rewards ===
  review_street_5star: 'テーマパーク全体が最高！お化け屋敷も怖くて施設も素晴らしい！',
  review_street_4star: '全体的に良い体験。お化け屋敷怖かったし、スナックも美味しかった。',
  review_street_3star: 'まあまあ。お化け屋敷にもっとお化けがいればいいのに。',
  review_street_2star: 'やることがあまりない。お化け屋敷も微妙。',
  review_street_1star: '時間の無駄。怖くもないし施設も少ない。',

  review_vip_satisfied: 'VIP: Perfect! I will definitely come back with my friends.',
  review_vip_unsatisfied: 'VIP: Very disappointing experience. Not worth my time.',

  season_halloween: 'Halloween',
  season_summer_fest: 'Summer Fest',
  season_winter_chill: 'Winter Chill',
  season_spring_bloom: 'Spring Bloom',

  ad_sp_boost: 'SP2倍ブースト（30秒）',
  ad_sp_boost_desc: '30秒間全SP収入が2倍',
  ad_recover_fatigue: '無料回復',
  ad_recover_fatigue_desc: '幽霊の疲労を無料で即時回復',
  ad_vip_visitor: 'VIP訪問者',
  ad_vip_visitor_desc: '高報酬のVIP訪問者グループを召喚',
  ad_skip_training: '訓練スキップ',
  ad_skip_training_desc: '訓練を即座に完了',
  ad_active_boost: '2倍SP発動中！',
  ad_rewards_title: '広告報酬',

  // === Business / Open-Close System ===
  day_label: 'Day {n}',
  hud_operation_day: '運営{n}日目',
  status_open: '営業中',
  status_closed: '閉店',
  manage_business: 'Manage Business',
  toggle_open: '営業開始',
  toggle_close: '営業終了',
  facility_open_badge: '営業中',
  need_ghost_to_open: 'まずゴーストを部屋に配置してください！',
  ticket_price: '入場料',
  ticket_price_label: '{n} SP',
  ticket_price_low: '訪問者多い、一人当たり収益少ない',
  ticket_price_high: '訪問者少ない、一人当たり収益多い',
  end_day: '一日を終了',
  day_summary_title: 'DAY {n} まとめ',
  day_summary_visitors: '訪問者数: {n}',
  day_summary_earnings: '収益: {n} SP',
  day_summary_avg_rating: '平均評価: {n}',
  day_summary_next: '終了して報酬を受け取る',
  day_summary_best_visitor: '{n}つ星の訪問!',
  day_summary_sp_collected: '合計SP��得',
  day_summary_sp_gain: '+{n}',
  day_summary_milestones: 'デイリー目標',
  day_summary_total_visits: '合計訪問',
  day_summary_reaction_5: '恐怖そのもの!',
  day_summary_reaction_4: '怖い!',
  day_summary_reaction_3: '悪くない',
  day_summary_reaction_2: 'うーん...',
  day_summary_reaction_1: '退屈...',

  milestone_visitors_5: '訪問者{target}人を迎える',
  milestone_visitors_10: '訪問者{target}人を迎える',
  milestone_visitors_20: '訪問者{target}人を迎える',
  milestone_earnings_1000: '{target} SPを稼ぐ',
  milestone_earnings_5000: '{target} SPを稼ぐ',
  milestone_earnings_10000: '{target} SPを稼ぐ',
  milestone_flee_0: '逃走者ゼロ',
  milestone_flee_1: '逃走者{target}人以下',
  milestone_rooms_3: '{target}部屋以上運営',
  milestone_rooms_5: '{target}部屋以上運営',
  milestone_ghosts_2: 'ゴースト{target}体以上配置',
  milestone_ghosts_3: 'ゴースト{target}体以上配置',
  milestone_reward: '+{n} SP',

  reviews_panel_title: '訪問者レビュー',
  reviews_panel_avg: '平均評価',
  reviews_panel_empty: 'まだレビューがありません',

  // --- Missing keys (English fallback) ---
  ghost_mummy: 'Mummy',
  ghost_werewolf: 'Werewolf',
  ghost_origin_egypt: 'Egypt',
  ghost_origin_europe: 'Europe',
  ghost_mummy_skill: 'Bandage Wrap: Entangles visitors, physical + visual scare',
  ghost_werewolf_skill: 'Full Moon Howl: Terrifying transformation, max physical + auditory',
  ghost_mummy_quote: 'These bandages are so itchy...',
  ghost_werewolf_quote: 'Is there a full moon tonight? I feel... different.',
  ghost_mummy_fatigued: 'My bandages came undone... I tripped...',
  ghost_werewolf_fatigued: 'Even wolves need sleep... woof... zzz...',
  tq_mummy_scream: 'Mummy practicing muffled screams through bandages...',
  tq_werewolf_scream: 'Werewolf howling at a picture of the moon...',
  tq_mummy_jumpscare: 'Mummy bursting out of sarcophagus repeatedly...',
  tq_werewolf_jumpscare: 'Werewolf practicing surprise transformations...',
  tq_mummy_psych: 'Mummy reading ancient curse scrolls for inspiration...',
  tq_werewolf_psych: 'Werewolf studying pack hunting psychology...',
  tq_mummy_atmo: 'Mummy arranging ancient Egyptian artifacts for ambiance...',
  tq_werewolf_atmo: 'Werewolf setting up moonlight projectors...',
  tq_mummy_physical: 'Mummy doing stretches to prevent bandage tangles...',
  tq_werewolf_physical: 'Werewolf doing 500 push-ups in wolf form...',
  tq_mummy_audience: 'Mummy researching which civilization visitors fear most...',
  tq_werewolf_audience: 'Werewolf tracking which visitors have dog allergies...',

  view_building: '建物',
  view_other_buildings: '< 他の建物を見る',
  view_lobby: '待合室',
  view_facilities: '付帯施設',
  view_academy: '教育院',
  lobby_title: '待合室',
  lobby_queue: '待ち行列',
  lobby_queue_empty: '待機中のお客様はいません',
  lobby_active_teams: '探検中: {cur}/{max}チーム',
  lobby_wait_time: '待ち: {n}秒',
  lobby_team_size: '{n}人',
  lobby_staff: 'ロビースタッフ',
  lobby_staff_empty: 'スタッフ未配置',
  lobby_assign_staff: 'スタッフ配置',
  lobby_unassign_staff: '解除',
  lobby_staff_effect: '待ち時間短縮、お客様満足度向上',
  lobby_ticket_booth: 'チケット売り場',
  facilities_view_title: '施設管理',
  facilities_view_empty: '施設がありません。メニューから建設してください!',
  facility_staff: 'スタッフ',
  facility_staff_none: 'スタッフなし',
  facility_assign_staff: 'スタッフ配置',
  facility_unassign_staff: 'スタッフ解除',
  facility_staff_bonus: 'スタッフ配置でサービス品質向上',
  facility_restroom: 'トイレ',
  facility_restroom_desc: '満足度ペナルティ防止',
  facility_restroom_bonus: '建設時ペナルティなし',
  facility_parking_lot: '駐車場',
  facility_parking_lot_desc: '来客数増加',
  facility_parking_lot_bonus: 'レベルごとに来客+{pct}%',
  facility_first_aid: '救護室',
  facility_first_aid_desc: '逃走/失神したお客様のケア',
  facility_first_aid_bonus: '逃走時の悪いレビュー防止',
  facility_arcade: 'アーケード',
  facility_arcade_desc: 'ミニゲーム＆ホラーアトラクション',
  facility_arcade_bonus: '来場者の興奮度アップ',
  facility_fortune_teller: '占い師',
  facility_fortune_teller_desc: '神秘のタロット＆手相占い',
  facility_fortune_teller_bonus: '来場者の満足度アップ',
  facility_escape_room: '脱出部屋',
  facility_escape_room_desc: '制限時間付きホラーパズル',
  facility_escape_room_bonus: '高い一人当たり収益',
  facility_stage: 'ステージ',
  facility_stage_desc: 'お化けショー＆パフォーマンス',
  facility_stage_bonus: 'パーク全体の名声アップ',
  facility_voodoo_shop: 'ブードゥーショップ',
  facility_voodoo_shop_desc: '呪いのお守りと魔法グッズ',
  facility_voodoo_shop_bonus: '特殊アイテムドロップ率アップ',
  facility_ghost_cafe: 'ゴーストカフェ',
  facility_ghost_cafe_desc: '幽霊が作る不思議な飲み物',
  facility_ghost_cafe_bonus: '来場者の滞在時間アップ',
  facility_phantom_cinema: 'ファントムシネマ',
  facility_phantom_cinema_desc: '超常現象ホラー映画上映',
  facility_phantom_cinema_bonus: '高いチケット収益',
  facility_skeleton_spa: 'スケルトンスパ',
  facility_skeleton_spa_desc: '骨までリラックスできる温泉',
  facility_skeleton_spa_bonus: 'おばけの疲労回復速度アップ',
  academy_title: 'おばけ教育院',
  academy_empty: 'まずおばけを雇用してください!',
  academy_select_ghost: '訓練するおばけを選択',
  academy_select_training: '教育コース選択',
  academy_skill_level: 'Lv.{n}/{max}',
  academy_skill_maxed: 'マスター',
  academy_training_time: '{sec}秒',
  academy_training_cost: '{sp} SP',
  academy_in_progress: '訓練中...',
  academy_complete: '完了!',
  academy_skip_ad: 'スキップ(広告)',
  academy_ghost_busy: 'おばけは忙しい',
  academy_acting: '演技レッスン',
  academy_acting_desc: '恐怖演技とタイミング向上',
  academy_acting_effect: 'レベルごとに恐怖効果+20%',
  academy_human_relations: '人間関係学',
  academy_human_relations_desc: '来客の理解を深める',
  academy_human_relations_effect: 'レベルごとに満足度+15%',
  academy_psychology: '心理学',
  academy_psychology_desc: '来客の弱点を突く',
  academy_psychology_effect: 'レベルごとに弱点ボーナス',
  academy_special_fx: '特殊効果',
  academy_special_fx_desc: '小道具の活用力向上',
  academy_special_fx_effect: 'レベルごとに小道具ボーナスx2',
  academy_fitness: '体力トレーニング',
  academy_fitness_desc: 'スタミナと持久力向上',
  academy_fitness_effect: 'レベルごとに疲労回復+50%',
  academy_teamwork: 'チームワーク',
  academy_teamwork_desc: '隣のおばけと連携',
  academy_teamwork_effect: 'レベルごとにチェインスケア+30%',
  academy_customer_service: '接客サービス',
  academy_customer_service_desc: 'ロビー/施設サービス向上',
  academy_customer_service_effect: 'レベルごとにサービス品質向上',
  facility_detail_income: '収入',
  facility_detail_sp_per_group: 'グループあたり {n} SP',
  facility_detail_bonus: 'ボーナス',
  facility_detail_upgrade: 'アップグレード ({sp} SP)',
  facility_detail_assign: 'スタッフ配置',
  facility_detail_status_active: '運営中',
  facility_detail_status_buildable: '建設可能',
  facility_detail_status_locked: 'ロック中',
  facility_detail_no_income: '直接収入なし',
  ghost_role_scare: '恐怖担当',
  ghost_role_lobby_staff: 'ロビースタッフ',
  ghost_role_facility_staff: '施設スタッフ',
  ghost_role_instructor: '教官',
  shop_pro_ghosts: 'Professional Ghosts',
  pro_ghost_badge: 'PRO',
  ghost_grim_reaper: 'Grim Reaper',
  ghost_origin_underworld: 'Underworld',
  ghost_grim_reaper_skill: 'Soul Harvest: All fear types S-rank, absolute terror',
  ghost_grim_reaper_quote: 'Your time has come... just kidding. Or am I?',
  ghost_grim_reaper_fatigued: 'Even death needs a vacation sometimes...',
  ghost_grim_reaper_unique: 'Instant max fear on any visitor type',
  ghost_blood_count: 'Blood Count',
  ghost_origin_transylvania: 'Transylvania',
  ghost_blood_count_skill: 'Blood Charm: Charisma-based visual + psychological S-rank',
  ghost_blood_count_quote: 'I do not drink... wine.',
  ghost_blood_count_fatigued: 'The sun... it burns... need coffin...',
  ghost_blood_count_unique: 'Charm aura: adjacent rooms get +20% scare',
  ghost_well_spirit: 'Well Spirit',
  ghost_well_spirit_skill: 'Well Crawl: Psychological horror S-rank, lingering dread',
  ghost_well_spirit_quote: '...seven days...',
  ghost_well_spirit_fatigued: 'My hair is so tangled... need conditioner...',
  ghost_well_spirit_unique: 'Lingering fear: visitors stay scared in next room',
  ghost_nightmare_specter: 'Nightmare Specter',
  ghost_origin_dreamworld: 'Dream World',
  ghost_nightmare_specter_skill: 'Nightmare Slash: Physical + psychological S-rank dream terror',
  ghost_nightmare_specter_quote: 'Sweet dreams... or not.',
  ghost_nightmare_specter_fatigued: 'Even nightmares need beauty sleep...',
  ghost_nightmare_specter_unique: 'Dream invasion: double scare on sleeping visitors',
  ghost_shadow_stalker: 'Shadow Stalker',
  ghost_origin_void: 'The Void',
  ghost_shadow_stalker_skill: 'Static Presence: Psychological horror max, stalker-type',
  ghost_shadow_stalker_quote: '...',
  ghost_shadow_stalker_fatigued: '......',
  ghost_shadow_stalker_unique: 'Static aura: all visitors on floor get +15% fear',

  // === Visitor Reactions ===
  reaction_angry: '#!',
  reaction_excited: '*',

  // === Lobby Building System ===
  lobby_room_ticket_booth: 'チケット売り場',
  lobby_room_ticket_booth_desc: '来場者がチケットを購入する場所',
  lobby_room_ticket_booth_effect: '基本チケット処理速度',
  lobby_room_waiting_lounge: '待合ラウンジ',
  lobby_room_waiting_lounge_desc: 'ソファ付きの快適な待合スペース',
  lobby_room_waiting_lounge_effect: 'レベルごとに来場者の忍耐力+20%',
  lobby_room_vip_lounge: 'VIPラウンジ',
  lobby_room_vip_lounge_desc: 'VIP来場者専用のプレミアム待合室',
  lobby_room_vip_lounge_effect: 'VIP来場者のSP消費2倍',
  lobby_room_reservation_center: '予約センター',
  lobby_room_reservation_center_desc: '来場者の事前予約システム',
  lobby_room_reservation_center_effect: 'レベルごとに来場者出現率+15%',

  lobby_build_floor: '+ {name} ({sp} SP)',
  lobby_build_select: '建設する施設を選択...',
  lobby_add_floor: '+ {sp} SP',
  lobby_empty_floor: '施設建設',
  lobby_select_facility: '施設を選択',
  lobby_props_count: '小道具 {n}個',
  lobby_props_title: 'オブジェクト',
  lobby_tab_info: '情報',
  lobby_tab_objects: 'オブジェクト',
  lobby_tab_upgrade: 'アップグレード',
  lobby_tab_demolish: '撤去',
  lobby_demolish_confirm: 'この施設を撤去しますか？フロアは残り、空きフロアになります。',
  lobby_demolish_btn: '施設撤去',
  lobby_no_ghost: 'スタッフなし',
  lobby_upgrade_max: '最大レベル',
  lobby_upgrade_next: 'Lv.{from} -> Lv.{to}',
  lobby_upgrade_effect: 'アップグレード後の効果:',
  facility_build_floor: '建設',

  facility_map_title: '施設エリア',
  facility_build_here: '建設',
  facility_select_to_build: '施設を選択',
  facility_all_built: '全ての施設が建設済みです。',
  facility_unlock_plot: '{sp} SP',
  facility_unlock_plot_title: '区画を解放',
  facility_unlock_plot_desc: '{sp} SPでこの区画を解放し、新しい施設を建設できます。',
  facility_unlock_plot_btn: '解放 ({sp} SP)',
  facility_build_popup_title: '施設を建設',
  facility_build_action: '建設',
  facility_select_theme: 'テーマを選択',
  facility_upgrade_preview: 'アップグレード効果',
  facility_upgrade_revenue: 'グループ当たり収益',
  facility_upgrade_bonus: '収益ボーナス',
  facility_upgrade_capacity: '収容人数',
  facility_upgrade_current: '現在',
  facility_upgrade_next: '次',
  facility_upgrade_max_level: '最大レベル到達',
  facility_revenue: '売上',
  facility_total_revenue: '総売上',
  facility_hourly_revenue: 'グループ毎',
  facility_set_price: '料金設定',
  facility_price_hint_high: '高価格: 利益増、利用率減',
  facility_price_hint_low: '低価格: 利用率増、利益減',
  facility_price_hint_free: '無料入場',
  facility_price_hint_normal: 'バランスの良い価格',
  facility_open: '開店',
  facility_close: '閉店',
  facility_closed_badge: '休業中',
  facility_needs_staff: 'スタッフを配置して開店',
  facility_demolish: '撤去',
  facility_demolish_confirm: '{name}を撤去しますか? 元に戻せません。',
  facility_move: '移動',
  facility_move_select: '移動先の空き区画を選択',
  facility_move_no_empty: '空き区画がありません。',

  lobby_prop_sofa: 'ソファ',
  lobby_prop_sofa_desc: '待機中の来場者用の快適な座席',
  lobby_prop_tv_screen: 'TVスクリーン',
  lobby_prop_tv_screen_desc: '待ち時間の娯楽',
  lobby_prop_vending_machine: '自動販売機',
  lobby_prop_vending_machine_desc: '来場者用の軽食と飲み物',
  lobby_prop_info_sign: '案内看板',
  lobby_prop_info_sign_desc: '来場者を正しい場所へ案内',
  lobby_prop_potted_plant: '鉢植え',
  lobby_prop_potted_plant_desc: '不気味な緑のインテリア',
  lobby_prop_umbrella_stand: '傘立て',
  lobby_prop_umbrella_stand_desc: '濡れた傘を置く場所',

  fac_prop_display_shelf: '陳列棚',
  fac_prop_display_shelf_desc: '商品を魅力的に展示',
  fac_prop_cash_register: 'レジスター',
  fac_prop_cash_register_desc: '取引速度向上',
  fac_prop_coffee_machine: 'コーヒーマシン',
  fac_prop_coffee_machine_desc: '温かい飲み物を提供',
  fac_prop_menu_board: 'メニューボード',
  fac_prop_menu_board_desc: '食べ物と飲み物のメニュー表示',
  fac_prop_camera_light: 'カメラライト',
  fac_prop_camera_light_desc: 'より良い写真照明',
  fac_prop_backdrop: '背景幕',
  fac_prop_backdrop_desc: 'テーマ付き写真背景',
  fac_prop_hand_dryer: 'ハンドドライヤー',
  fac_prop_hand_dryer_desc: '清潔で乾燥した状態を保つ',
  fac_prop_mirror: '鏡',
  fac_prop_mirror_desc: '不気味なトイレの必需品',
  fac_prop_parking_sign: '駐車場看板',
  fac_prop_parking_sign_desc: '来場者を駐車場へ案内',
  fac_prop_barrier_gate: 'バリアゲート',
  fac_prop_barrier_gate_desc: '自動駐車管理',
  fac_prop_first_aid_kit: '救急箱',
  fac_prop_first_aid_kit_desc: '基本的な医療用品',
  fac_prop_stretcher: '担架',
  fac_prop_stretcher_desc: '恐怖で気絶した来場者用',

  tab_support_facilities: '付帯施設',
  tab_achievements: '実績',
  achievements_title: '実績',
  achievements_coming_soon: '準備中...',
  tab_facilities: '施設',
  tab_hire: '採用',
  tab_staff: 'スタッフ',
  facilities_mgmt_title: '施設管理',
  facility_condition: '劣化度',
  facility_hygiene: '衛生度',
  facility_condition_warning: '修理が必要です!',
  facility_hygiene_warning: '清掃が必要です!',
  dispatch_repair: '修理派遣',
  dispatch_clean: '清掃派遣',
  no_repair_staff: '修理スタッフがいません',
  no_janitor_staff: '清掃スタッフがいません',
  repair_dispatched: '修理スタッフを派遣しました',
  clean_dispatched: '清掃スタッフを派遣しました',
  ticket_section_title: 'チケット価格',
  expected_visitors: '予想来場者: ~{n}人/日',
  star_rating_title: '来場者評価',
  star_level_gray: 'グレースター',
  star_level_bronze: 'ブロンズスター',
  star_level_silver: 'シルバースター',
  star_level_gold: 'ゴールドスター',
  star_level_rainbow: 'レインボースター',
  star_evolution_max: '最高のお化け屋敷',
  star_current: '{cur}/{max}',
  hire_title: 'スタッフ採用',
  hire_scare_section: '恐怖専門家',
  hire_staff_section: '施設スタッフ',
  staff_role_repair: '修理工',
  staff_role_janitor: '清掃員',
  staff_role_ticket: 'チケット販売員',
  staff_role_guide: 'ガイド',
  staff_role_repair_desc: '施設の劣化を修理',
  staff_role_janitor_desc: '施設の衛生を管理',
  staff_role_ticket_desc: 'ロビーを運営',
  staff_role_guide_desc: '来場者満足度ボーナス',
  hire_cost_label: '{sp} SP',
  staff_title: 'スタッフ一覧',
  staff_empty: 'まだスタッフがいません。',
  staff_detail_title: 'スタッフ詳細',
  staff_detail_type: '種類',
  staff_detail_role: '役割',
  staff_detail_grade: 'グレード',
  staff_detail_skills: 'スキル',
  staff_detail_assigned: '配置先',
  staff_detail_not_assigned: '未配置',
  staff_detail_hired_days: '入社: Day {n}',
  staff_detail_praise: '称賛: {n}',
  skill_acting: '演技力',
  skill_friendliness: '親和力',
  skill_psychology: '心理学',
  skill_special_fx: '特殊効果',
  skill_fitness: '体力',
  skill_teamwork: 'チームワーク',
  skill_service: '顧客サービス',
  room_detail_tab_info: '部屋情報',
  room_detail_tab_props: '設備',
  room_detail_tab_upgrade: 'アップグレード',
  room_detail_tab_demolish: '解体',
  room_detail_ghost_none: '未配置',
  room_detail_condition: '耐久度',
  room_detail_hygiene: '清潔度',
  room_detail_request_repair: '修理依頼 ({sp} SP)',
  room_detail_request_cleaning: '清掃依頼 ({sp} SP)',
  room_detail_repairing: '修理中... {sec}秒',
  room_detail_cleaning: '清掃中... {sec}秒',
  room_detail_collapsed: '崩壊',
  room_detail_collapsed_desc: '部屋が崩壊しました。修理で復旧できます。',
  room_detail_condition_ok: '耐久度良好',
  room_detail_hygiene_ok: '清潔度良好',
  room_upgrade_structure: '構造強化',
  room_upgrade_structure_desc: '訪問ごとの耐久度減少を軽減',
  room_upgrade_structure_effect: 'レベルごとに耐久度減少 -{pct}%',
  room_upgrade_structure_bonus_10: '頑丈な部屋: 修理費 -30%',
  room_upgrade_structure_bonus_20: '不滅の部屋: 耐久度最低50維持',
  room_upgrade_purify: '自動浄化',
  room_upgrade_purify_desc: '訪問ごとの清潔度減少を軽減',
  room_upgrade_purify_effect: 'レベルごとに清潔度減少 -{pct}%',
  room_upgrade_purify_bonus_10: '芳香の部屋: 満足度 +10%',
  room_upgrade_purify_bonus_20: '自動清掃魔法: 清潔度自動回復',
  room_upgrade_level: 'Lv.{cur}/{max}',
  room_upgrade_cost: 'アップグレード ({sp} SP)',
  room_upgrade_max: '最大',
  room_upgrade_bonus_unlocked: '解放済み!',
  room_upgrade_bonus_locked: 'Lv.{n} ボーナス',
  room_demolish_warning: 'この部屋を解体すると、全ての設備とアップグレードが失われます。',
  room_demolish_cost: 'コスト: 無料',
  room_demolish_btn: '解体する',
  room_demolish_confirm: '本当にこの部屋を解体しますか？元に戻せません。',
  room_props_installed: '設置済みの装飾品',
  room_props_available: '設置可能な装飾品',
  room_props_none: '装飾品なし',
  menu_bgm: 'BGM',
  menu_sfx: 'SFX',
  menu_language: '言語',
  menu_reset: 'ゲームリセット',
  menu_reset_confirm: '全ての進行状況をリセットしますか？元に戻せません。',
  menu_info: 'ゲーム情報',
  menu_version: 'バージョン {v}',
  menu_on: 'ON',
  menu_off: 'OFF',

  // === Room Emotion Stats ===
  stat_fear: '恐怖度',
  stat_thrill: 'スリル',
  stat_atmosphere: '雰囲気',
  stat_fun: '楽しさ',
  stat_total: '部屋ステータス',
  room_grade: 'ランク',
  grade_S: 'S',
  grade_A: 'A',
  grade_B: 'B',
  grade_C: 'C',
  grade_D: 'D',
  grade_F: 'F',

  // === Story Arc System ===
  // === Day Phase Cycle ===
  phase_day: '\u6E96\u5099',
  phase_evening: '\u55B6\u696D\u4E2D',
  phase_night: '\u9589\u5E97',
  phase_day_icon: '\u2600',
  phase_evening_icon: '\uD83C\uDF19',
  phase_night_icon: '\u2B50',
  phase_remaining: '{sec}\u79D2',
  phase_day_hint: '\u304A\u5316\u3051\u5C4B\u6577\u3092\u6E96\u5099\uFF01\u4FEE\u7406\u3001\u304A\u5316\u3051\u914D\u7F6E\u3001\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u3002',
  phase_evening_hint: '\u55B6\u696D\u6642\u9593\uFF01\u304A\u5BA2\u69D8\u304C\u6765\u307E\u3059\u3002',
  open_now_btn: '\u4ECA\u3059\u3050\u958B\u5E97',
  speed_btn: 'x{n}',
  day_auto_open_hint: '\u5915\u65B9\u306B\u306A\u308A\u307E\u3057\u305F\uFF01\u958B\u5E97\u3057\u307E\u3057\u3087\u3046\u3002',
  evening_ending_hint: '\u9589\u5E97\u6642\u9593\uFF01\u7247\u4ED8\u3051\u4E2D...',
  floor1_blocked_warning: '\u5165\u5834\u4E0D\u53EF\uFF011\u968E\u3092\u4FEE\u7406\u3057\u3066\u304F\u3060\u3055\u3044\uFF01',
  gstaff_title: '\u5e7d\u970a\u30b9\u30bf\u30c3\u30d5',
  gstaff_repairman: '\u4fee\u7406\u5e7d\u970a',
  gstaff_repairman_desc: '\u58c1\u3092\u3059\u308a\u629c\u3051\u3066\u90e8\u5c4b\u3092\u4fee\u7406\u3059\u308b\u6709\u80fd\u306a\u5e7d\u970a',
  gstaff_repairman_effect: '\u6700\u3082\u8010\u4e45\u5ea6\u306e\u4f4e\u3044\u90e8\u5c4b\u3092\u81ea\u52d5\u4fee\u7406',
  gstaff_janitor: '\u6e05\u6383\u5e7d\u970a',
  gstaff_janitor_desc: '\u970a\u529b\u3067\u90e8\u5c4b\u3092\u304d\u308c\u3044\u306b\u3057\u307e\u3059',
  gstaff_janitor_effect: '\u6700\u3082\u6e05\u6f54\u5ea6\u306e\u4f4e\u3044\u90e8\u5c4b\u3092\u81ea\u52d5\u6e05\u6383',
  gstaff_promoter: '\u5ba3\u4f1d\u5e7d\u970a',
  gstaff_promoter_desc: '\u4e0d\u6c17\u5473\u306a\u56c1\u304d\u3067\u5ba2\u3092\u547c\u3073\u8fbc\u307f\u307e\u3059',
  gstaff_promoter_effect: '\u30ec\u30d9\u30eb\u3054\u3068\u306b\u8a2a\u554f\u8005+20%',
  gstaff_medic: '\u7652\u3057\u5e7d\u970a',
  gstaff_medic_desc: '\u6016\u3048\u305f\u5ba2\u3092\u5e7d\u970a\u306e\u9b45\u529b\u3067\u843d\u3061\u7740\u304b\u305b\u307e\u3059',
  gstaff_medic_effect: '\u9003\u3052\u305f\u304a\u5ba2\u69d8\u306e\u30ec\u30d3\u30e5\u30fc\u3092\u4e2d\u7acb\u306b',
  gstaff_security: '\u8b66\u5099\u5e7d\u970a',
  gstaff_security_desc: '\u5a01\u5727\u7684\u306a\u5b58\u5728\u611f\u3067\u79e9\u5e8f\u3092\u7dad\u6301\u3057\u307e\u3059',
  gstaff_security_effect: '\u30ec\u30d9\u30eb\u3054\u3068\u306b\u6e80\u8db3\u5ea6+10%',
  gstaff_hire_cost: '\u53ec\u559a: {sp} SP',
  gstaff_salary: '\u7dad\u6301\u8cbb: {sp} SP/\u65e5',
  gstaff_fire: '\u9664\u970a',
  gstaff_fire_confirm: '\u3053\u306e\u5e7d\u970a\u30b9\u30bf\u30c3\u30d5\u3092\u9664\u970a\u3057\u307e\u3059\u304b\uff1f',
  gstaff_level: 'Lv.{n}',
  gstaff_none: '\u53ec\u559a\u3055\u308c\u305f\u5e7d\u970a\u30b9\u30bf\u30c3\u30d5\u304c\u3044\u307e\u305b\u3093\u3002',
  day_summary_salaries: '\u30B9\u30BF\u30C3\u30D5\u7D66\u4E0E',
  day_summary_net_earnings: '\u7D14\u53CE\u76CA',
  day_summary_street_visitors: '\u8857\u306E\u8A2A\u554F\u8005',
  day_summary_street_revenue: '\u8857\u306E\u53CE\u76CA',
  day_summary_reviews_title: '\u8A2A\u554F\u8005\u30EC\u30D3\u30E5\u30FC',
  day_summary_avg_stars: '\u5E73\u5747\u8A55\u4FA1',
  day_summary_fame_change: '\u540D\u58F0',
  day_summary_no_reviews: '\u4ECA\u65E5\u306E\u30EC\u30D3\u30E5\u30FC\u306A\u3057',
  day_summary_review_visitor: '\u8A2A\u554F\u8005 #{n}',
  day_summary_highlight: '\u30CF\u30A4\u30E9\u30A4\u30C8',

  // === Tutorial ===
  tutorial_welcome_title: '\u304A\u5316\u3051\u5C4B\u6577\u3078\u3088\u3046\u3053\u305D!',
  tutorial_welcome_body: '\u3042\u306A\u305F\u306F\u4ECA\u65E5\u304B\u3089\u304A\u5316\u3051\u5C4B\u6577\u306E\u30AA\u30FC\u30CA\u30FC\u3067\u3059\u3002\u304A\u5316\u3051\u305F\u3061\u3068\u4E00\u7DD2\u306B\u697D\u3057\u3044\u304A\u5316\u3051\u5C4B\u6577\u3092\u4F5C\u308A\u307E\u3057\u3087\u3046!',
  tutorial_welcome_btn: '\u59CB\u3081\u3088\u3046!',
  tutorial_build_title: '\u90E8\u5C4B\u3092\u4F5C\u308D\u3046',
  tutorial_build_body: '\u307E\u305A\u90E8\u5C4B\u3092\u4F5C\u308A\u307E\u3057\u3087\u3046\u3002\u300C+\u300D\u30DC\u30BF\u30F3\u3092\u30BF\u30C3\u30D7\u3057\u3066\u90E8\u5C4B\u30BF\u30A4\u30D7\u3092\u9078\u3093\u3067\u304F\u3060\u3055\u3044\u3002',
  tutorial_ghost_title: '\u304A\u5316\u3051\u3092\u914D\u7F6E\u3057\u3088\u3046',
  tutorial_ghost_body: '\u90E8\u5C4B\u306B\u304A\u5316\u3051\u3092\u914D\u7F6E\u3057\u3066\u304A\u5BA2\u3055\u3093\u3092\u9A5A\u304B\u305B\u307E\u3057\u3087\u3046\u3002\u90E8\u5C4B\u3092\u30BF\u30C3\u30D7\u3057\u3066\u304A\u5316\u3051\u3092\u914D\u7F6E\u3057\u3066\u304F\u3060\u3055\u3044\u3002',
  tutorial_open_title: '\u958B\u9928\u3057\u3088\u3046',
  tutorial_open_body: '\u6E96\u5099\u5B8C\u4E86! \u4E0B\u306E\u300C\u958B\u9928\u300D\u30DC\u30BF\u30F3\u3092\u30BF\u30C3\u30D7\u3057\u3066\u304A\u5BA2\u3055\u3093\u3092\u8FCE\u3048\u307E\u3057\u3087\u3046\u3002',
  tutorial_facility_intro_title: '\u65BD\u8A2D\u30A8\u30EA\u30A2',
  tutorial_facility_intro_body: '\u30D1\u30FC\u30AF\u306B\u306F\u65BD\u8A2D\u3092\u5EFA\u3066\u308B\u533A\u753B\u304C\u3042\u308A\u307E\u3059! \u304A\u5E97\u3084\u30A2\u30C8\u30E9\u30AF\u30B7\u30E7\u30F3\u3092\u5EFA\u3066\u3066\u53CE\u76CA\u3092\u5897\u3084\u3057\u307E\u3057\u3087\u3046\u3002',
  tutorial_facility_build_title: '\u65BD\u8A2D\u3092\u5EFA\u8A2D',
  tutorial_facility_build_body: '\u7A7A\u304D\u533A\u753B\u3092\u30BF\u30C3\u30D7\u3057\u3066\u65BD\u8A2D\u3092\u9078\u3073\u307E\u3057\u3087\u3046\u3002\u304A\u571F\u7523\u5C4B\u3084\u30B9\u30CA\u30C3\u30AF\u30D0\u30FC\u304C\u304A\u3059\u3059\u3081!',
  tutorial_facility_staff_title: '\u30B9\u30BF\u30C3\u30D5\u914D\u7F6E',
  tutorial_facility_staff_body: '\u65B0\u3057\u3044\u65BD\u8A2D\u306B\u304A\u5316\u3051\u3092\u914D\u7F6E\u3057\u307E\u3057\u3087\u3046\u3002\u30B9\u30BF\u30C3\u30D5\u304C\u3044\u308B\u3068\u53CE\u76CA\u304C20%\u30A2\u30C3\u30D7!',
  tutorial_facility_open_title: '\u65BD\u8A2D\u3092\u30AA\u30FC\u30D7\u30F3',
  tutorial_facility_open_body: '\u65BD\u8A2D\u3092\u30AA\u30FC\u30D7\u30F3\u3059\u308B\u3068\u304A\u5BA2\u3055\u3093\u304C\u5229\u7528\u3067\u304D\u307E\u3059\u3002\u6599\u91D1\u3082\u8A2D\u5B9A\u3067\u304D\u307E\u3059!',
  tutorial_done_title: '\u30C1\u30E5\u30FC\u30C8\u30EA\u30A2\u30EB\u5B8C\u4E86!',
  tutorial_done_body: '\u7D20\u6674\u3089\u3057\u3044! \u3053\u308C\u3067\u57FA\u672C\u64CD\u4F5C\u306F\u30D0\u30C3\u30C1\u30EA\u3067\u3059\u3002\u304A\u5316\u3051\u5C4B\u6577\u3092\u5927\u304D\u304F\u3057\u3066\u3044\u304D\u307E\u3057\u3087\u3046!',
  tutorial_skip: '\u30B9\u30AD\u30C3\u30D7',
  tutorial_next: '\u6B21\u3078',
  tutorial_got_it: '\u308F\u304B\u3063\u305F!',

  story_intro: '起',
  story_rising: '承',
  story_climax: '転',
  story_resolution: '結',
  story_grade: 'ストーリー: {grade} (+{bonus}% SP)',
  story_bonus: '+{bonus}% SP',
  story_guide_title: 'ストーリーアークシステム解放!',
  story_guide_desc: '4部屋以上で起承転結の動線を作ると、ボーナスSPが獲得できます!',
  story_role_label: '{role}',
  story_intro_desc: '雰囲気作り: 高い雰囲気、低い恐怖',
  story_rising_desc: '緊張感の上昇: 恐怖とスリルを増加',
  story_climax_desc: '恐怖の頂点: 恐怖とスリルを最大化',
  story_resolution_desc: '解放と楽しさ: 楽しさを強化',
  story_room_role: 'ストーリー役割: {role}',
  story_none: 'なし',

  // === Room Available Props ===
  room_available_props: '設置可能: {props}',

  // === Lobby Queue System ===
  lq_waiting_count: '待機: {n}/{max}',
  lq_avg_patience: '平均忍耐力: {n}%',
  lq_queue_empty: '待機列に来場者がいません',

  // === Lobby Facilities ===
  lf_title: 'ロビー施設',
  lf_patience_bonus: '忍耐力 -{n}%',
  lf_revenue_bonus: '+{n} SP/来場者',
  lf_npc_bonus: 'NPCスタッフ: 忍耐力+15%、収益+20%',
  lf_npc_staff: 'NPCスタッフ',

  lf_ticket_booth: 'チケットブース',
  lf_ticket_booth_desc: '必須チケット発券カウンター',
  lf_waiting_lounge: '待合ラウンジ',
  lf_waiting_lounge_desc: '快適な座席がある待機スペース (+忍耐力)',
  lf_vip_lounge: 'VIPラウンジ',
  lf_vip_lounge_desc: 'VIP訪問者専用プレミアム待合室',
  lf_reservation_center: '予約センター',
  lf_reservation_center_desc: '訪問者の事前予約システム (+忍耐力)',
  lf_poster_wall: 'ポスター壁',
  lf_poster_wall_desc: '不気味なポスターで期待感アップ（+忍耐力）',
  lf_snack_cart: 'スナックカート',
  lf_snack_cart_desc: 'おやつで来場者の忍耐力を維持',
  lf_souvenir_booth: 'お土産ブース',
  lf_souvenir_booth_desc: 'お土産販売で追加収益',
  lf_photo_zone: 'フォトゾーン',
  lf_photo_zone_desc: '写真撮影で名声と収益アップ',
  lf_tv_monitor: 'TVモニター',
  lf_tv_monitor_desc: '恐怖ハイライト映像で退屈解消',
  lf_costume_rental: 'コスチュームレンタル',
  lf_costume_rental_desc: 'コスチューム貸出で楽しさと収益追加',
  lf_fortune_booth: '占いブース',
  lf_fortune_booth_desc: '神秘的な占いで恐怖の雰囲気を演出',
  lf_built_badge: '建設済',

  // === Lobby Facility Unique Effects ===
  lf_ue_ticket_speed: 'チケット速度: レベルごとに入場間隔 -15%',
  lf_ue_max_queue_up: '収容人数: レベルごとに最大待機人数 +5',
  lf_ue_vip_rate_up: 'VIP率: レベルごとにVIP来場率 x2',
  lf_ue_satisfaction_up: '期待感: 基本満足度 +20%',
  lf_ue_emergency_patience: '緊急スナック: 忍耐力の低い来場者に +15回復',
  lf_ue_revisit_rate_up: 'お土産: 翌日の来場者ボーナス +15%',
  lf_ue_reputation_per_day: 'SNSシェア: レベルごとに毎日の評判 +2',
  lf_ue_anticipation_up: 'ホラープレビュー: 期待感 +40%',
  lf_ue_fun_bonus: 'コスチューム: レベルごとに楽しさ +15',
  lf_ue_random_sp_bonus: '占い: ランダムボーナスSP確率 +10%',
  ticket_price_setting: '入場料設定',

  // === Lobby Facility Props ===
  lobby_prop_candle: 'キャンドル',
  lobby_prop_candle_desc: '雰囲気のある揺れるキャンドル',
  lobby_prop_cobweb: '蜘蛛の巣',
  lobby_prop_cobweb_desc: '不気味に垂れ下がる蜘蛛の巣',
  lobby_prop_pumpkin: 'カボチャ',
  lobby_prop_pumpkin_desc: '定番のジャックランタン',
  lobby_prop_magazine_rack: '雑誌ラック',
  lobby_prop_magazine_rack_desc: '待ち時間にホラー雑誌を',
  lobby_prop_chandelier: 'シャンデリア',
  lobby_prop_chandelier_desc: '優雅なゴシック風シャンデリア',
  lobby_prop_wine_glass: 'ワイングラス',
  lobby_prop_wine_glass_desc: 'VIP気分のクリスタルグラス',
  lobby_prop_velvet_curtain: 'ベルベットカーテン',
  lobby_prop_velvet_curtain_desc: '高級感あるベルベットドレープ',
  lobby_prop_gold_frame: 'ゴールドフレーム',
  lobby_prop_gold_frame_desc: '装飾的な金の額縁',
  lobby_prop_picture_frame: '額縁',
  lobby_prop_picture_frame_desc: '壁に掛けられた呪われた肖像画',
  lobby_prop_spotlight: 'スポットライト',
  lobby_prop_spotlight_desc: '展示物用のドラマチックな照明',
  lobby_prop_skull_ornament: '骸骨オーナメント',
  lobby_prop_skull_ornament_desc: '不気味な雰囲気の装飾用骸骨',
  lobby_prop_pumpkin_cookie: 'パンプキンクッキー',
  lobby_prop_pumpkin_cookie_desc: '美味しいカボチャ型クッキー',
  lobby_prop_ghost_drink: 'ゴーストドリンク',
  lobby_prop_ghost_drink_desc: '不思議に光る飲み物',
  lobby_prop_napkin_holder: 'ナプキンホルダー',
  lobby_prop_napkin_holder_desc: 'スナックコーナーを清潔に',
  lobby_prop_display_shelf: '陳列棚',
  lobby_prop_display_shelf_desc: 'お土産を魅力的に展示',
  lobby_prop_plush_doll: 'ぬいぐるみ',
  lobby_prop_plush_doll_desc: 'かわいいおばけぬいぐるみ',
  lobby_prop_keychain_rack: 'キーホルダーラック',
  lobby_prop_keychain_rack_desc: '不気味なキーホルダーの回転ラック',
  lobby_prop_wrapping_paper: 'ラッピングペーパー',
  lobby_prop_wrapping_paper_desc: 'ハロウィンテーマのギフト包装紙',
  lobby_prop_backdrop: '背景幕',
  lobby_prop_backdrop_desc: 'テーマ別フォト背景',
  lobby_prop_prop_box: '小道具ボックス',
  lobby_prop_prop_box_desc: '楽しいフォトアクセサリーの箱',
  lobby_prop_mask_stand: 'マスクスタンド',
  lobby_prop_mask_stand_desc: '撮影用の不気味なマスク展示',
  lobby_prop_antenna: 'アンテナ',
  lobby_prop_antenna_desc: 'TV信号受信機',
  lobby_prop_remote_control: 'リモコン',
  lobby_prop_remote_control_desc: 'TVチャンネル操作用',
  lobby_prop_speaker: 'スピーカー',
  lobby_prop_speaker_desc: 'ホラー映像用サラウンドサウンド',
  lobby_prop_cable_wires: 'ケーブル配線',
  lobby_prop_cable_wires_desc: '絡まった配線が不気味さを増す',
  lobby_prop_clothes_rack: '衣装ラック',
  lobby_prop_clothes_rack_desc: '不気味な衣装が掛かったラック',
  lobby_prop_mirror: '鏡',
  lobby_prop_mirror_desc: '衣装確認用の全身鏡',
  lobby_prop_makeup_table: 'メイクアップテーブル',
  lobby_prop_makeup_table_desc: '不気味なメイクをする場所',
  lobby_prop_wig_stand: 'ウィッグスタンド',
  lobby_prop_wig_stand_desc: '不気味なウィッグコレクション',
  lobby_prop_crystal_ball: '水晶玉',
  lobby_prop_crystal_ball_desc: '不気味な未来を覗く',
  lobby_prop_tarot_cards: 'タロットカード',
  lobby_prop_tarot_cards_desc: '神秘的な占いカード',
  lobby_prop_curtain: 'カーテン',
  lobby_prop_curtain_desc: '占いブース用の神秘的なカーテン',
  lobby_prop_candelabra: '燭台',
  lobby_prop_candelabra_desc: '雰囲気のある多腕キャンドルホルダー',

  // === Lobby NPC Ghost ===
  lnpc_title: 'Lobby Ghost Patrol',
  lnpc_assign: 'Assign Ghost',
  lnpc_unassign: 'Remove',
  lnpc_desc: 'Ghosts scare waiting visitors, boosting patience',
  lnpc_slot: '{cur}/{max} Ghosts',

  // === Random Event System ===
  evt_time_remaining: '{sec}s remaining',
  evt_rain_name: 'Sudden Rain',
  evt_rain_desc: 'Heavy rain falls suddenly. Visitors without umbrellas are leaving the queue.',
  evt_rain_c1: 'Ignore',
  evt_rain_c2: 'Hand out umbrellas (100 SP)',
  evt_rain_r1: '3 visitors left the queue in the rain.',
  evt_rain_r2: 'Umbrellas were handed out. Everyone stays dry.',
  evt_couple_fight_name: 'Couple Fight',
  evt_couple_fight_desc: 'A couple starts arguing loudly in the queue, disturbing others.',
  evt_couple_fight_c1: 'Handle it',
  evt_couple_fight_r1: 'The situation has been dealt with.',
  evt_crying_child_name: 'Crying Child',
  evt_crying_child_desc: 'A child starts crying in the queue, making others uneasy.',
  evt_crying_child_c1: 'Give candy (50 SP)',
  evt_crying_child_c2: 'Ignore',
  evt_crying_child_r1: 'The candy cheered the child up.',
  evt_crying_child_r2: 'The crying continued, testing everyone\'s patience.',
  evt_blackout_name: 'Power Outage',
  evt_blackout_desc: 'A sudden power outage plunges everything into darkness.',
  evt_blackout_c1: 'Start generator (200 SP)',
  evt_blackout_c2: 'Wait it out',
  evt_blackout_r1: 'The generator kicked in. Business continues.',
  evt_blackout_r2: 'Everyone waited in the dark for a while.',
  evt_line_cutter_name: 'Line Cutter',
  evt_line_cutter_desc: 'Someone brazenly cuts into the front of the queue.',
  evt_line_cutter_c1: 'Call security',
  evt_line_cutter_c2: 'Ignore',
  evt_line_cutter_r1: 'Security escorted the line cutter out.',
  evt_line_cutter_r2: 'Others in line grumble in frustration.',
  evt_fake_ghost_name: 'Fake Ghost Prank',
  evt_fake_ghost_desc: 'A visitor dressed as a ghost is scaring others in line. The crowd seems amused.',
  evt_fake_ghost_c1: 'Let them have fun',
  evt_fake_ghost_r1: 'The prank added to the spooky atmosphere. Reputation up!',
  evt_lost_item_name: 'Lost Item Report',
  evt_lost_item_desc: 'A visitor reports a lost item near the entrance.',
  evt_lost_item_c1: 'Help find it (Reputation +5)',
  evt_lost_item_c2: 'Ignore',
  evt_lost_item_r1: 'The lost item was found! The visitor is grateful.',
  evt_lost_item_r2: 'The visitor left disappointed.',
  evt_snack_sold_out_name: 'Snacks Sold Out',
  evt_snack_sold_out_desc: 'The snack cart ran out of stock. Visitors are asking for snacks.',
  evt_snack_sold_out_c1: 'Emergency restock (100 SP)',
  evt_snack_sold_out_c2: 'Wait for next shipment',
  evt_snack_sold_out_r1: 'Snacks are back in stock.',
  evt_snack_sold_out_r2: 'Visitors will have to wait.',
  evt_sns_selfie_name: 'SNS Photo Op',
  evt_sns_selfie_desc: 'A visitor wants to take a selfie for social media.',
  evt_sns_selfie_c1: 'Acknowledge',
  evt_sns_selfie_r1: 'The post boosted your online presence.',
  evt_hot_weather_name: 'Scorching Heat',
  evt_hot_weather_desc: 'The temperature soars. Visitors look uncomfortable in the heat.',
  evt_hot_weather_c1: 'Free drinks (150 SP)',
  evt_hot_weather_c2: 'Endure it',
  evt_hot_weather_r1: 'Cool drinks refreshed everyone.',
  evt_hot_weather_r2: 'The heat is taking a toll on patience.',
  evt_tour_bus_name: 'Tour Bus Arrival',
  evt_tour_bus_desc: 'A tour bus just arrived! A large group of tourists floods the entrance.',
  evt_tour_bus_c1: 'Welcome them',
  evt_tour_bus_r1: 'The queue fills up with excited tourists.',
  evt_tv_coverage_name: 'TV Crew Request',
  evt_tv_coverage_desc: 'A local TV station wants to cover your haunted house.',
  evt_tv_coverage_c1: 'Accept (risky)',
  evt_tv_coverage_c2: 'Decline',
  evt_tv_coverage_r1: 'The coverage aired. Results vary...',
  evt_tv_coverage_r2: 'You politely declined the offer.',
  evt_spy_name: 'Rival Spy',
  evt_spy_desc: 'You spot someone suspiciously taking notes about your operations.',
  evt_spy_c1: 'Apprehend (need security)',
  evt_spy_c2: 'Ignore',
  evt_spy_r1: 'The spy was caught. You recovered valuable intel.',
  evt_spy_r2: 'Some of your ideas might leak to competitors.',
  evt_health_inspection_name: 'Health Inspection',
  evt_health_inspection_desc: 'Health inspectors arrive for a surprise visit.',
  evt_health_inspection_c1: 'Open the doors',
  evt_health_inspection_r1: 'The inspection is complete.',
  evt_halloween_season_name: 'Halloween Fever',
  evt_halloween_season_desc: 'Halloween spirit fills the air! Everyone is in the mood for scares.',
  evt_halloween_season_c1: 'Celebrate!',
  evt_halloween_season_r1: 'Halloween boost! Extra visitors and SP incoming.',
  evt_ghost_strike_name: 'Ghost Strike',
  evt_ghost_strike_desc: 'Overworked ghosts are refusing to scare. They demand better conditions.',
  evt_ghost_strike_c1: 'Pay bonus (500 SP)',
  evt_ghost_strike_c2: 'Wait it out',
  evt_ghost_strike_r1: 'The bonus satisfied the ghosts. Back to work!',
  evt_ghost_strike_r2: 'The strike continues for a while...',
  evt_mystery_visitor_name: 'Mystery Critic',
  evt_mystery_visitor_desc: 'A famous horror critic is visiting in disguise. Results depend on your reputation.',
  evt_mystery_visitor_c1: 'Best behavior',
  evt_mystery_visitor_r1: 'The critic revealed themselves and wrote a review.',
  evt_maintenance_accident_name: 'Equipment Malfunction',
  evt_maintenance_accident_desc: 'A piece of equipment malfunctioned in one of the rooms!',
  evt_maintenance_accident_c1: 'Assess damage',
  evt_maintenance_accident_r1: 'A room sustained damage. Repairs needed.',
  evt_sns_viral_name: 'Viral Video',
  evt_sns_viral_desc: 'A visitor\'s video of your haunted house went viral online!',
  evt_sns_viral_c1: 'Ride the wave',
  evt_sns_viral_r1: 'Your fame skyrockets! Reputation and SP boosted.',
  evt_total_blackout_name: 'Total Blackout',
  evt_total_blackout_desc: 'All power goes out across the entire area. Complete darkness.',
  evt_total_blackout_c1: 'Candlelight event (+Rep)',
  evt_total_blackout_c2: 'Wait for power',
  evt_total_blackout_r1: 'The candlelight atmosphere was a hit!',
  evt_total_blackout_r2: 'Everyone waited in the dark.',
  evt_famous_youtuber_name: 'Famous Streamer',
  evt_famous_youtuber_desc: 'A famous horror streamer with millions of followers is live-streaming from your haunted house!',
  evt_famous_youtuber_c1: 'Give VIP treatment',
  evt_famous_youtuber_r1: 'The stream was a massive hit! Reputation +30, SP +2000.',
  evt_celeb_visit_name: 'Celebrity Visit',
  evt_celeb_visit_desc: 'A major celebrity has arrived for a private scare session!',
  evt_celeb_visit_c1: 'Roll out the red carpet',
  evt_celeb_visit_r1: 'The celebrity loved it! Huge publicity boost.',
  evt_franchise_offer_name: 'Franchise Offer',
  evt_franchise_offer_desc: 'A corporation wants to franchise your haunted house brand.',
  evt_franchise_offer_c1: 'Accept (10000 SP)',
  evt_franchise_offer_c2: 'Decline',
  evt_franchise_offer_r1: 'Deal signed! A hefty payment arrives.',
  evt_franchise_offer_r2: 'You prefer to stay independent.',
  evt_intl_contest_name: 'International Horror Contest',
  evt_intl_contest_desc: 'Your haunted house is invited to an international scare competition!',
  evt_intl_contest_c1: 'Enter the contest',
  evt_intl_contest_r1: 'You earned recognition on the world stage!',
  evt_documentary_name: 'Documentary Filming',
  evt_documentary_desc: 'A documentary crew wants to film the story of your haunted house.',
  evt_documentary_c1: 'Allow filming',
  evt_documentary_r1: 'The documentary premieres to rave reviews!',
  evt_ghost_king_name: 'The Ghost King Appears',
  evt_ghost_king_desc: 'A legendary ghost is drawn to your haunted house by its fame.',
  evt_ghost_king_c1: 'Welcome the Ghost King',
  evt_ghost_king_r1: 'The Ghost King joins your ranks! Morale soars.',
  evt_gov_subsidy_name: 'Government Grant',
  evt_gov_subsidy_desc: 'The tourism board awards your haunted house a cultural preservation grant.',
  evt_gov_subsidy_c1: 'Accept the grant',
  evt_gov_subsidy_r1: 'Grant received: 5000 SP!',
  evt_vip_party_name: 'VIP Party Request',
  evt_vip_party_desc: 'A wealthy patron wants to rent the entire haunted house for a private party.',
  evt_vip_party_c1: 'Accept (8000 SP)',
  evt_vip_party_c2: 'Decline',
  evt_vip_party_r1: 'The VIP party was a huge success!',
  evt_vip_party_r2: 'You keep the doors open for regular visitors.',
  evt_horror_festival_name: 'Horror Festival',
  evt_horror_festival_desc: 'The city is hosting a horror festival and your haunted house is the main attraction!',
  evt_horror_festival_c1: 'Lead the festival',
  evt_horror_festival_r1: 'The festival was legendary! Massive rewards earned.',
  evt_legendary_review_name: 'Legendary Review',
  evt_legendary_review_desc: 'The world\'s most famous horror critic publishes a glowing review of your haunted house.',
  evt_legendary_review_c1: 'Bask in glory',
  evt_legendary_review_r1: 'A flood of 5-star reviews and fame follows!',

  // === Event Defense System ===
  evt_defense_badge: 'Auto-Resolved!',
  evt_defense_bonus: 'Bonus: +{sp} SP',
  evt_rain_defense: 'The roof upgrade keeps everyone dry. No one leaves!',
  evt_rain_hint: 'Tip: Upgrade Poster Wall to Lv.3 to auto-defend against rain.',
  evt_couple_fight_defense: 'Security steps in and mediates the situation calmly.',
  evt_couple_fight_hint: 'Tip: Hire a Security guard to auto-resolve fights.',
  evt_crying_child_defense: 'The snack cart attendant offers candy. The child smiles!',
  evt_crying_child_hint: 'Tip: Build a Snack Cart to automatically comfort crying children.',
  evt_blackout_defense: 'Emergency generators kick in automatically. No interruption!',
  evt_blackout_hint: 'Tip: Upgrade facilities to total Lv.10+ for backup power.',
  evt_line_cutter_defense: 'Security handles the line cutter immediately. Order restored!',
  evt_line_cutter_hint: 'Tip: Hire a Security guard to auto-handle line cutters.',
  evt_fake_ghost_defense: 'Your real NPC ghosts outshine the impostor. Excitement rises!',
  evt_fake_ghost_hint: 'Tip: Assign at least 1 NPC ghost to the lobby to overshadow fakers.',
  evt_lost_item_defense: 'Your staff quickly locates and returns the lost item!',
  evt_lost_item_hint: 'Tip: Hire 3+ staff members to auto-find lost items.',
  evt_snack_sold_out_defense: 'Inventory auto-restocked from reserves. Sales continue!',
  evt_snack_sold_out_hint: 'Tip: Upgrade Snack Cart to Lv.2+ for auto-restocking.',
  evt_sns_selfie_defense: 'Photo Zone provides the perfect backdrop. Great shots posted!',
  evt_sns_selfie_hint: 'Tip: Build a Photo Zone for automatic photo opportunities.',
  evt_hot_weather_defense: 'The monitor area has air conditioning. Everyone stays cool!',
  evt_hot_weather_hint: 'Tip: Install a TV Monitor to provide a cooled waiting area.',
  evt_tour_bus_defense: 'Plenty of room! All tourists are welcomed in.',
  evt_tour_bus_hint: 'Tip: Expand queue capacity to 15+ to accept large groups.',
  evt_tv_coverage_defense: 'With great reputation and many ghosts, the broadcast is a hit!',
  evt_tv_coverage_hint: 'Tip: Reach reputation 50+ and hire 5+ ghosts for guaranteed success.',
  evt_spy_defense: 'Security catches the spy red-handed! Intel recovered.',
  evt_spy_hint: 'Tip: Hire a Security guard to auto-detect spies.',
  evt_health_inspection_defense: 'Spotless! The inspector awards a hygiene certificate.',
  evt_health_inspection_hint: 'Tip: Hire a Janitor and keep average hygiene above 70.',
  evt_ghost_strike_defense: 'Ghosts are well-rested and happy. No strike today!',
  evt_ghost_strike_hint: 'Tip: Keep average ghost fatigue below 30 to prevent strikes.',
  evt_mystery_visitor_defense: 'Your excellent reputation earns a glowing review!',
  evt_mystery_visitor_hint: 'Tip: Maintain reputation at 60+ for guaranteed good reviews.',
  evt_maintenance_accident_defense: 'The repairman fixes it on the spot. Minimal damage!',
  evt_maintenance_accident_hint: 'Tip: Hire a Repairman to minimize equipment damage.',
  evt_total_blackout_defense: 'Repairman restores power instantly. Candle event bonus!',
  evt_total_blackout_hint: 'Tip: Hire a Repairman and reach facility Lv.15+ total.',
  evt_vip_party_defense: 'Costumes and photo zone make the party unforgettable! Normal business continues too.',
  evt_vip_party_hint: 'Tip: Build Costume Rental and Photo Zone for the ultimate party.',

  // === World Street ===
  world_title: '建物',
  world_subtitle: '管理する建物を選択してください',
  world_empty_plot: '空き地',
  world_build_new: '新しいテーマのお化け屋敷を建てる',

  rename_building: '建物名を変更',
  rename_building_desc: '新しい建物名を入力してください',
  rename: '変更',
  building_renamed: '建物名が変更されました！',

  construction_title: '新築',
  construction_subtitle: '新しいお化け屋敷を建てよう！',
  construction_name_label: '建物名',
  construction_name_placeholder: '例: 深夜の館',
  construction_theme_label: 'テーマ',
  construction_start: '建設する',
  world_status_build: '建設',
  world_status_open: '営業中',
  world_status_ready: '準備中',
  theme_haunted_house: 'お化け屋敷',
  theme_haunted_house_desc: 'クラシックな可愛いお化け体験',
  theme_abandoned_hospital: '廃病院',
  theme_abandoned_hospital_desc: '医療ホラーと実験室の雰囲気',
  theme_school_back_mountain: '学校の裏山',
  theme_school_back_mountain_desc: '学校の怪談と山道の雰囲気',
  theme_cursed_circus: '呪われたサーカス',
  theme_cursed_circus_desc: '呪われたサーカステントの不気味な恐怖',
  theme_ancient_temple: '古代寺院',
  theme_ancient_temple_desc: '古代寺院の神秘的で不気味な呪い',
  theme_pirate_ship: '海賊船',
  theme_pirate_ship_desc: '呪われた海賊船の海の恐怖',
  theme_abandoned_mine: '廃坑',
  theme_abandoned_mine_desc: '廃坑の深く暗い恐怖',
  theme_gothic_castle: 'ゴシック城',
  theme_gothic_castle_desc: 'ゴシック城の優雅で不気味な貴族の恐怖',
  theme_underground_bunker: '地下バンカー',
  theme_underground_bunker_desc: '地下バンカーの実験と陰謀の恐怖',
  theme_cursed_forest: '呪われた森',
  theme_cursed_forest_desc: '呪われた森の自然霊と原始の恐怖',

  synergy_active_count: 'シナジー{n}個発動中',
  synergy_popup_title: '発動中のシナジー',
  syn_fx_dark_mirror_e1: '鏡の幻影',
  syn_fx_dark_mirror_e2: 'ドッペルゲンガーの呪い',
  syn_fx_underground_horror_e1: '地下牢の絶叫',
  syn_fx_underground_horror_e2: '死の残響',
  syn_fx_restless_spirits_e1: '死者のため息',
  syn_fx_restless_spirits_e2: '亡霊の行列',
  syn_fx_creepy_collection_e1: '人形の呪い',
  syn_fx_creepy_collection_e2: '鏡の中の迷宮',
  syn_fx_mad_scientist_e1: '狂気の実験',
  syn_fx_mad_scientist_e2: '錬金術の報酬',
  syn_fx_hidden_paths_e1: '影の迷路',
  syn_fx_hidden_paths_e2: '隠された恐怖',
  syn_fx_circus_nightmare_e1: 'ピエロの遊び',
  syn_fx_circus_nightmare_e2: 'サーカスの悪夢',
  syn_fx_ancient_curse_e1: '古代の呪い',
  syn_fx_ancient_curse_e2: 'ミイラの怒り',
  syn_fx_hidden_treasures_e1: '財宝の誘惑',
  syn_fx_hidden_treasures_e2: '地下の発見',
  syn_fx_ship_of_doom_e1: '海の鎮魂歌',
  syn_fx_ship_of_doom_e2: 'デイヴィ・ジョーンズの罰',
  syn_fx_prison_horror_e1: '牢獄の脱出',
  syn_fx_prison_horror_e2: '鎖の束縛',
  syn_fx_deep_descent_e1: '水晶の輝き',
  syn_fx_deep_descent_e2: '地下の神秘',
  syn_fx_boom_scare_e1: '爆発の余波',
  syn_fx_boom_scare_e2: '連鎖爆発',
  syn_fx_royal_terror_e1: '王の怒り',
  syn_fx_royal_terror_e2: '王室の財宝',
  syn_fx_noble_cellar_e1: 'ワインの香り',
  syn_fx_noble_cellar_e2: '秘密の貯蔵庫',
  syn_fx_quarantine_protocol_e1: '隔離警報',
  syn_fx_quarantine_protocol_e2: '生物学的脅威',
  syn_fx_nature_wrath_e1: '魔女の霧',
  syn_fx_nature_wrath_e2: '大地の怒り',
  syn_fx_ancient_power_e1: '古代の力',
  syn_fx_ancient_power_e2: '神秘の遺跡',
  syn_fx_echo_chamber_e1: '反響の呪い',
  syn_fx_echo_chamber_e2: '音の幻影',
  syn_fx_water_horror_e1: '深淵の恐怖',
  syn_fx_water_horror_e2: '水の囁き',
  syn_fx_full_course_e1: 'フルコースの宴',
  syn_fx_full_course_e2: '満足の笑顔',
  synergy_dark_mirror: 'ダークミラー',
  synergy_dark_mirror_desc: '暗い廊下 + 鏡の部屋: 雰囲気+15%, 恐怖+10%',
  synergy_underground_horror: 'アンダーグラウンドホラー',
  synergy_underground_horror_desc: 'ダンジョン/棺桶の組み合わせ: 恐怖+20%, スリル+10%',
  synergy_restless_spirits: '落ち着かない霊',
  synergy_restless_spirits_desc: '墓地/棺桶/霊安室: 雰囲気+20%, 来客+10%',
  synergy_creepy_collection: 'クリーピーコレクション',
  synergy_creepy_collection_desc: '人形/鏡/ファンハウス: 恐怖+15%, スリル+10%',
  synergy_mad_scientist: 'マッドサイエンティスト',
  synergy_mad_scientist_desc: '実験室/手術室/科学: スリル+20%, SP+15%',
  synergy_hidden_paths: '隠された道',
  synergy_hidden_paths_desc: '秘密通路/廊下/屋根裏: 雰囲気+15%, チェーン+20%',
  synergy_circus_nightmare: 'サーカスナイトメア',
  synergy_circus_nightmare_desc: 'ファンハウス/フリークショー/トラペーズ: 楽しさ+20%, 恐怖+15%',
  synergy_ancient_curse: '古代の呪い',
  synergy_ancient_curse_desc: '祭壇/呪いの部屋/ミラの墓: 恐怖+25%, スリル+15%',
  synergy_hidden_treasures: '隠された財宝',
  synergy_hidden_treasures_desc: '宝物庫 + 地下川: SP+20%, 来客+10%',
  synergy_ship_of_doom: 'ドゥーム号',
  synergy_ship_of_doom_desc: '船長室/貨物室/デイビ: 雰囲気+15%, 恐怖+15%',
  synergy_prison_horror: 'プリズンホラー',
  synergy_prison_horror_desc: '監禁室 + デイビ: スリル+20%, スリル+10%',
  synergy_deep_descent: '深層降下',
  synergy_deep_descent_desc: '鉱山/水晶洞/地下湖: 雰囲気+20%, 来客+15%',
  synergy_boom_scare: 'ボームスケア',
  synergy_boom_scare_desc: '爆薬庫 + トンネル: スリル+25%, チェーン+15%',
  synergy_royal_terror: 'ロイヤルテラー',
  synergy_royal_terror_desc: '玉座/塔/ワイン: 恐怖+15%, SP+20%',
  synergy_noble_cellar: '貴族のセラー',
  synergy_noble_cellar_desc: 'ワインセラー + 秘密通路: 雰囲気+15%, SP+10%',
  synergy_quarantine_protocol: '隔離プロトコル',
  synergy_quarantine_protocol_desc: 'サーバー室/隔離区域/武器庫: スリル+20%, 恐怖+10%',
  synergy_nature_wrath: '自然の怒り',
  synergy_nature_wrath_desc: '魔女/沼地/妖精: 雰囲気+20%, スリル+10%',
  synergy_ancient_power: '古代の力',
  synergy_ancient_power_desc: '遺跡/妖精/祭壇: 恐怖+20%, 来客+15%',
  synergy_echo_chamber: 'エコーチェンバー',
  synergy_echo_chamber_desc: '音楽室/図書館/廊下: チェーン+25%, 雰囲気+10%',
  synergy_water_horror: 'ウォーターホラー',
  synergy_water_horror_desc: '浴室/地下川/地下湖: 恐怖+15%, 雰囲気+15%',
  synergy_full_course: 'フルコース',
  synergy_full_course_desc: 'キッチン/浴室/音楽室: 楽しさ+25%, 来客+20%',
};

export default ja;
